import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button } from "../../../Common/UI/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";

interface ISaveScheduleViewProps {
  goBack: () => void;
  isDisabled: boolean;
  onSave: () => void;
}

// Responsible for rendering create schedule form
export const SaveScheduleView = (props: ISaveScheduleViewProps): JSX.Element => {
  const { goBack, isDisabled, onSave } = props;
  const { t: translate } = useTranslation();
  return (
    <div className="ebt-new-schedule__footer">
      <Button
        data-testid="ebt-new-schedule-save"
        variant={ButtonVariantType.FILLED}
        disabled={isDisabled}
        onClick={onSave}
      >
        {translate("Button.Save")}
      </Button>
      <Button
        data-testid="ebt-new-schedule-cancel"
        borderless={true}
        onClick={goBack}
      >
        {translate("Button.Cancel")}
      </Button>
    </div>
  );
};
